const initialState = {
    isOpen: false,
    rejectReason: '',
    factorNum: 0,
    factorKey: 0, // indexe marbut be factorha
};
const modalRejectFactor = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_MODAL_REJECT_FACTOR':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default modalRejectFactor;
